/* DUO shared behaviour. Loaded once, from sections/duo-header.liquid.

   No scroll reveals (2026-09-26): content is always visible. The old
   reveal-on-scroll left whole sections blank in full-page captures at 430 and
   could do the same in a slow in-app browser. Motion now lives only in the
   hero bubbles, hovers and the marquee, and stops for reduced motion. */
(function(){
  if (window.__duo) return; window.__duo = true;
  var root = document.documentElement; root.classList.add('duo-js');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* "Ordering open" off (Theme settings > DUO): nothing on the page may reach the cart or
     checkout, whatever section or Horizon script is switched on later. Every button we show
     already says Save my drink; this catches anything that was missed, including Enter in a
     product form. It cannot stop someone typing /checkout or a cart link by hand.
     The one way in: "Save my drink" puts her drink in the cart (Paul + Kellie, Nov 2: "we make
     the saved drink go in your cart"); it sets DUO_SAVING around its own add. Checkout stays
     off: the cart shows no checkout button while ordering is off (snippets/duo-cart-closed). */
  if (window.DUO_DELIVERY && window.DUO_DELIVERY.open === false) {
    var duoAdd = /\/cart\/add(\.js)?(\?|$)/;
    document.addEventListener('submit', function(e){
      var f = e.target, act = f && f.getAttribute && f.getAttribute('action') || '';
      if (duoAdd.test(act) || (e.submitter && e.submitter.name === 'checkout')) e.preventDefault();
    }, true);
    if (window.fetch) {
      var duoFetch = window.fetch;
      window.fetch = function(u){
        if (duoAdd.test(String(u && u.url || u)) && !window.DUO_SAVING) return Promise.reject(new Error('Ordering opens soon.'));
        return duoFetch.apply(this, arguments);
      };
    }
  }

  /* Save my drink puts the drink in her cart first (Paul + Kellie, Nov 2). Shopify's form check
     (hCaptcha) holds every customer form's submit and sends it itself, so this runs first, in the
     capture phase: the drink goes in the cart (the builder's lines, or the Little she picked), then
     the same submit is asked for again and Shopify's check sends it as it always did. A cart that
     refuses never stops the save. */
  document.addEventListener('submit', function(e){
    var f = e.target;
    if (!f || f.id !== 'duo-save-form' || f.__duoCarted || !window.fetch || !f.requestSubmit) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (f.__duoCarting) return;
    f.__duoCarting = true;
    savedTo(f);
    var job;
    if (typeof f.duoToCart === 'function') job = f.duoToCart();
    else {
      var panel = f.closest('[data-duo-save-panel]'), lit = f.closest('[data-lit-form]'), items = [];
      var v = panel && panel.getAttribute('data-duo-save-variant');
      if (lit) {
        var r = lit.querySelector('input[name="id"]:checked'), q = lit.querySelector('input[name="quantity"]:checked');
        if (r) items.push({ id: Number(r.value), quantity: Number(q && q.value) || 1 });
      } else if (v) items.push({ id: Number(v), quantity: 1 });
      job = items.length ? duoSaveAdd(items) : null;
    }
    // at most 4 seconds: the save itself never waits on a slow cart
    Promise.race([Promise.resolve(job).catch(function(){}), new Promise(function(r){ setTimeout(r, 4000); })]).then(function(){
      f.__duoCarted = true;
      f.requestSubmit();
    });
  }, true);
  function duoSaveAdd(items){
    window.DUO_SAVING = true;
    var p = fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) });
    window.DUO_SAVING = false;
    return p.then(function(r){ return r.ok; }, function(){ return false; });
  }
  window.duoSaveAdd = duoSaveAdd;
  /* The email she saved under, for the "Saved" line after the page comes back (one tab only). */
  function savedTo(f){
    var i = f.querySelector('[name="contact[email]"]');
    try { if (i && i.value) sessionStorage.setItem('duo:savedto', i.value.trim()); } catch (x) { /* fine */ }
  }
  window.duoSavedTo = savedTo;

  /* Shopify marks every customer form on the page as "posted" after any one of
     them is sent. The browser keeps the #id of the form that was actually sent,
     so every other form goes back to its fields. */
  function posted(){
    if (location.search.indexOf('customer_posted=true') === -1 && !document.querySelector('[data-duo-err]')) return;
    var sent = location.hash ? location.hash.slice(1) : '';
    document.querySelectorAll('form[id]').forEach(function(f){
      var ok = f.querySelector('[data-duo-ok]'), fields = f.querySelector('[data-duo-fields]'), err = f.querySelector('[data-duo-err]');
      var mine = !sent || f.id === sent;
      if (!mine) {
        if (ok) ok.hidden = true;
        if (fields) fields.hidden = false;
        if (err) err.hidden = true;
        f.classList.remove('is-posted');
      } else if ((ok && !ok.hidden) || err) {
        f.classList.add('is-posted');
        var panel = f.closest('[data-duo-save-panel]'); if (panel) panel.hidden = false;
        var buy = f.closest('[data-duo-build], .duo-pdp__buy'); if (buy && ok && !ok.hidden) buy.classList.add('is-saving');
        var nx = panel && panel.querySelector('[data-duo-save-next]'); if (nx && ok && !ok.hidden) nx.hidden = false;
        // a visitor: the email she typed, so a typo or a second address shows right here (Kellie's mom, Nov 2)
        var to = ok && ok.querySelector('[data-duo-saved-to]');
        if (to && !to.textContent) try { var em = sessionStorage.getItem('duo:savedto'); if (em) { to.textContent = em; to.parentNode.hidden = false; } } catch (x) { /* fine */ }
        if (f.classList.contains('duo-zip__wait')) f.classList.add('is-open');
        var det = f.closest('details'); if (det) det.open = true;
      }
    });
    // The hero keeps its own open/closed logic; tell it which form was sent.
    document.dispatchEvent(new CustomEvent('duo:posted', { detail: { id: sent } }));
  }

  /* Secret Menu countdown. Counts to the date in data-countdown; when that is
     blank or has passed, to midnight (local time) on the 1st of next month, the
     day each month's drink lands. It rolls over by itself every month, so it
     never sits at 00. */
  function nextFirst(now){ return new Date(now.getFullYear(), now.getMonth() + 1, 1, 0, 0, 0, 0).getTime(); }
  function countdowns(){
    document.querySelectorAll('[data-countdown]').forEach(function(el){
      if (el.dataset.cdReady) return; el.dataset.cdReady = 1;
      var fixed = new Date(el.getAttribute('data-countdown') || '').getTime();
      function tick(){
        var now = Date.now();
        var end = !isNaN(fixed) && fixed > now ? fixed : nextFirst(new Date(now));
        var d = Math.max(0, end - now);
        var parts = { d: Math.floor(d/864e5), h: Math.floor(d/36e5)%24, m: Math.floor(d/6e4)%60, s: Math.floor(d/1e3)%60 };
        Object.keys(parts).forEach(function(k){ var n = el.querySelector('[data-'+k+']'); if (n) n.textContent = String(parts[k]).padStart(2,'0'); });
        setTimeout(tick, 1000);
      }
      tick();
    });
  }

  function videos(){
    var vids = document.querySelectorAll('video[data-duo-autoplay]');
    if (!vids.length) return;
    if (reduce) { vids.forEach(function(v){ v.removeAttribute('autoplay'); v.pause(); }); return; }
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ var v = e.target; if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function(){}); } else { v.pause(); } });
    }, { threshold: 0.25 });
    vids.forEach(function(v){ io.observe(v); });
  }

  /* The product page's bottom bar shows once she has scrolled past the value pills
     (the last thing above the card) and the main button is off screen. On first view
     it stayed off: it sat on the moving pill row (phone audit, 2026-09-27). */
  var watching = [];   // the product section's observers: dropped when a flavour is swapped in place
  function watch(fn, el){ var io = new IntersectionObserver(fn); io.observe(el); watching.push(io); }
  function sticky(){
    var bar = document.querySelector('[data-duo-sticky]');
    var main = document.querySelector('[data-duo-add]') || document.querySelector('.duo-pdp__buy');
    var mark = document.querySelector('.duo-vals') || document.querySelector('.duo-pdp__title');
    if (!bar || !main || !('IntersectionObserver' in window)) return;
    // both answers are in before the bar is touched: a bar carried over from the last flavour stays as it is
    var btnSeen = null, past = mark ? null : true;
    function paint(){ if (btnSeen === null || past === null) return; bar.classList.toggle('is-on', past && !btnSeen); }
    watch(function(es){ btnSeen = es[es.length - 1].isIntersecting; paint(); }, main);
    if (mark) watch(function(es){
      var e = es[es.length - 1]; past = !e.isIntersecting && e.boundingClientRect.top < 0; paint();
    }, mark);
  }

  /* The product page's loops (drifting bubbles, the value pill row) pause when off
     screen; the pill row stops for good once she starts building. */
  var building = false;
  document.addEventListener('duo:touched', function(){
    building = true;
    var v = document.querySelector('.duo-pdp .duo-vals'); if (v) v.classList.add('is-still');
  });
  function stillLoops(){
    var pdp = document.querySelector('.duo-pdp');
    if (!pdp || !('IntersectionObserver' in window)) return;
    var vals = pdp.querySelector('.duo-vals'), stage = pdp.querySelector('.duo-pdp__stage');
    if (stage) watch(function(es){ pdp.classList.toggle('is-still', !es[es.length - 1].isIntersecting); }, stage);
    if (vals) {
      if (building) vals.classList.add('is-still');
      watch(function(es){ if (!building) vals.classList.toggle('is-still', !es[es.length - 1].isIntersecting); }, vals);
    }
  }
  /* A flavour swapped in place (assets/duo-builder.js): the new product section gets
     what a page load gives it. */
  document.addEventListener('duo:swapped', function(){
    watching.forEach(function(io){ io.disconnect(); });
    watching = [];
    nextDays(); sticky(); stillLoops(); qty(); zips(); saveOpen(); guestAdd(); minGate();
  });

  /* Plain product forms only. The builder runs its own quantity box
     ([data-duo-qty]); binding it here too made every tap count twice. */
  function qty(){
    document.querySelectorAll('.duo-qty:not([data-duo-qty])').forEach(function(q){
      if (q.dataset.qtyReady) return; q.dataset.qtyReady = 1;
      var input = q.querySelector('input');
      q.addEventListener('click', function(e){
        var b = e.target.closest('button'); if (!b) return;
        var v = parseInt(input.value || '1', 10) + (b.dataset.step === '+' ? 1 : -1);
        input.value = Math.max(1, Math.min(99, v));
      });
    });
  }

  /* Postal code checker (snippets/duo-postal.liquid). */
  var PC = /^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z](\d[ABCEGHJ-NPRSTV-Z]\d)?$/;
  function list(s){ return (s || '').toUpperCase().split(/[\s,]+/).filter(Boolean); }
  function zips(){
    document.querySelectorAll('[data-duo-zip]').forEach(function(z){
      if (z.dataset.zipReady) return; z.dataset.zipReady = 1;
      var zone = list(z.dataset.zone), near = list(z.dataset.near), d = z.dataset;
      var f = z.querySelector('[data-duo-zip-form]'), inp = f && f.querySelector('input');
      var out = z.querySelector('[data-duo-zip-out]'), wait = z.querySelector('.duo-zip__wait');
      var tags = wait && wait.querySelector('[data-duo-zip-tags]');
      if (!f || !inp || !out) return;

      function say(strong, rest, go){
        out.textContent = '';
        var b = document.createElement('b'); b.textContent = strong; out.appendChild(b);
        if (rest) out.appendChild(document.createTextNode(' ' + rest));
        /* A yes is the moment to pick a drink. Not on a drink page, where the
           buy card is already right there. */
        if (go && !document.querySelector('[data-duo-build]')) {
          var a = document.createElement('a');
          a.className = 'duo-link duo-zip__go'; a.href = '/collections/all'; a.textContent = 'Pick your drink →';
          out.appendChild(document.createTextNode(' ')); out.appendChild(a);
        }
      }
      function check(quiet){
        var v = inp.value.toUpperCase().replace(/[^A-Z0-9]/g, '');
        if (!PC.test(v)) {
          if (!quiet) say("That doesn't look like a postal code.", 'It looks like L4L 1A1.');
          if (wait && !wait.classList.contains('is-posted')) wait.classList.remove('is-open');
          return;
        }
        var fsa = v.slice(0, 3);
        // Days and fees only exist here once Paul has confirmed them (theme setting).
        var soon = d.soon ? 'First deliveries start ' + d.soon + '.' : '';
        var when = d.days ? d.days + ', ' + d.window + '.' + (soon ? ' ' + soon : '') : soon;
        var status;
        if (zone.indexOf(fsa) > -1) {
          status = 'zone';
          say('Yes, we deliver to ' + fsa + '.', when, true);
        } else if (near.indexOf(fsa) > -1) {
          status = 'near';
          say('Yes, we come to ' + fsa + '.', (when ? when + ' ' : '') + (d.extra ? 'Delivery is ' + d.extra + ' more there.' : 'Delivery costs a little more there.'), true);
        } else {
          status = 'out';
          say('Not yet.', "Leave your email and we'll tell you the day we reach " + fsa + '.');
        }
        if (wait) {
          wait.classList.toggle('is-open', status === 'out' || wait.classList.contains('is-posted'));
          if (tags) tags.value = 'delivery-waitlist,fsa-' + fsa.toLowerCase();
        }
        try { localStorage.setItem('duo:zip', v); } catch(e){}
        document.dispatchEvent(new CustomEvent('duo:zip', { detail: { fsa: fsa, status: status } }));
      }
      f.addEventListener('submit', function(e){ e.preventDefault(); check(false); });
      if (wait && wait.classList.contains('is-posted')) wait.classList.add('is-open');
      try { var last = localStorage.getItem('duo:zip'); if (last && !inp.value) { inp.value = last; check(true); } } catch(e){}
    });
  }

  /* Pages without the builder (Little DUO): the closed button opens the
     "Save my drink" panel in the same buy box. */
  function saveOpen(){
    var askSave = /[?&]save=1/.test(location.search);
    document.querySelectorAll('[data-duo-save-open]').forEach(function(b){
      if (b.dataset.soReady) return; b.dataset.soReady = 1;
      b.addEventListener('click', function(ev){
        var box = b.closest('.duo-pdp__buy') || document;
        var p = box.querySelector('[data-duo-save-panel]'); if (!p) return;
        p.hidden = false; if (box.classList) box.classList.add('is-saving');
        // signed in and already on the list: one tap saves (snippets/duo-save.liquid)
        var sf = p.querySelector('form');
        if (ev.isTrusted && p.hasAttribute('data-duo-onetap') && sf && sf.requestSubmit) { sf.requestSubmit(); return; }
        var i = p.querySelector('input[type=email]'); if (i) setTimeout(function(){ i.focus(); }, 200);
      });
      if (askSave) { askSave = false; b.click(); }   // arrived from a menu card or the cart: the email box is already open
    });
  }

  /* A Plus One is part of its drink (Paul, 2026-10-01: the same Plus One showed three
     times in the cart, each with its own quantity buttons). In the cart it is one small
     line under its drink with no controls (snippets/cart-products.liquid), and this keeps
     the cart true after every change:
       - a drink line leaves: the Plus Ones mixed into it (same _build id) leave with it,
         so a Plus One can never be checked out on its own;
       - a drink's quantity changes: its Plus Ones follow (6 cans, 6 of each Plus One).
         Shopify may hold one Plus One as several lines (the "one is on us" offer splits
         it); the whole amount goes on its first line and Shopify splits it again.
     One request, and the cart is redrawn in place from the same answer (Horizon's cart
     listens for 'shopify:cart:lines-update'); a full reload only if that is not possible. */
  var sweeping = false;
  function cartSections(){
    var ids = [];
    document.querySelectorAll('cart-items-component').forEach(function(c){ var id = c.dataset.sectionId; if (id && ids.indexOf(id) < 0) ids.push(id); });
    return ids;
  }
  function cartApply(updates){
    var ids = cartSections(), body = { updates: updates };
    if (ids.length) { body.sections = ids.join(','); body.sections_url = location.pathname; }
    return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(j){
        if (!j) return;
        if (j.sections && ids.length && ids.every(function(id){ return j.sections[id]; })) {
          var ev = new Event('shopify:cart:lines-update', { bubbles: true });
          ev.duoTidy = true;
          ev.promise = Promise.resolve({ cart: { totalQuantity: j.item_count }, detail: { sections: j.sections, itemCount: j.item_count } });
          document.dispatchEvent(ev);
        } else location.reload();
      });
  }
  function tidyCart(){
    if (sweeping) return; sweeping = true;
    var free = function(){ sweeping = false; };
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(c){
        var cans = {}, groups = {}, updates = {}, n = 0;
        // Only a drink keeps its Plus Ones. The Little DUO paired with it shares the
        // same _build id, so it must not count, or a lone Plus One could stay behind.
        c.items.forEach(function(i){ var b = i.properties && i.properties._build; if (b && i.product_type !== 'Plus One' && i.product_type !== 'Little DUO') cans[b] = (cans[b] || 0) + i.quantity; });
        c.items.forEach(function(i){
          if (i.product_type !== 'Plus One') return;
          var b = i.properties && i.properties._build;
          if (!b || !cans[b]) { updates[i.key] = 0; n++; return; }
          var g = b + '|' + i.variant_id;
          (groups[g] = groups[g] || { want: cans[b], lines: [] }).lines.push(i);
        });
        Object.keys(groups).forEach(function(g){
          var G = groups[g], have = 0;
          G.lines.forEach(function(i){ have += i.quantity; });
          if (have === G.want) return;
          G.lines.forEach(function(i, k){ updates[i.key] = k === 0 ? G.want : 0; });
          n++;
        });
        if (!n) return;
        return cartApply(updates);
      })
      .then(free, free);
  }

  /* The next delivery day, in Toronto time: the first delivery weekday whose cut-off
     (the night before) has not passed, skipping full or closed days
     (Theme settings > DUO > Delivery, snippets/duo-delivery-config.liquid). */
  var WEEK = ['sunday','monday','tuesday','wednesday','thursday','friday','saturday'];
  function torontoNow(){
    var n = new Date();
    try {
      var p = {};
      new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Toronto', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', hourCycle: 'h23' })
        .formatToParts(n).forEach(function(x){ p[x.type] = x.value; });
      return { y: +p.year, m: +p.month - 1, d: +p.day, h: +p.hour % 24 };
    } catch (e) { return { y: n.getFullYear(), m: n.getMonth(), d: n.getDate(), h: n.getHours() }; }
  }
  function closedDays(){
    var c = window.DUO_DELIVERY && window.DUO_DELIVERY.closed;
    return String(c || '').split(/[\s,;]+/).filter(function(s){ return /^\d{4}-\d{2}-\d{2}$/.test(s); });
  }
  function deliveryOptions(daysTxt, cut, startIso, max){
    var txt = String(daysTxt || '').toLowerCase(), out = [];
    var want = WEEK.map(function(d, i){ return txt.indexOf(d) > -1 ? i : -1; }).filter(function(i){ return i > -1; });
    if (!want.length) return out;
    var closed = closedDays(), t = torontoNow(), base = Date.UTC(t.y, t.m, t.d);
    for (var o = 1; o <= 42 && out.length < (max || 1); o++) {
      var d = new Date(base + o * 864e5), iso = d.toISOString().slice(0, 10);
      if (startIso && iso < startIso) continue;
      if (want.indexOf(d.getUTCDay()) < 0) continue;
      if (o === 1 && t.h >= cut) continue;
      if (closed.indexOf(iso) > -1) continue;
      out.push({ iso: iso, label: d.toLocaleDateString('en-CA', { timeZone: 'UTC', weekday: 'long', month: 'long', day: 'numeric' }) });
    }
    return out;
  }
  function nextDelivery(daysTxt, cut, startIso){ return deliveryOptions(daysTxt, cut, startIso, 1)[0] || null; }
  /* The menu page's cut-off line (sections/duo-menu.liquid, assets/duo-menu.js) reads the same
     next day this file stamps on the cart, so the two never disagree. */
  window.duoDeliveryNext = function(){
    var c = window.DUO_DELIVERY;
    if (!c || !c.open) return null;
    var cut = parseInt(c.cutoff, 10) || 20, o = nextDelivery(c.days, cut, c.start);
    if (!o) return null;
    var t = torontoNow(), away = Math.round((Date.parse(o.iso + 'T00:00:00Z') - Date.UTC(t.y, t.m, t.d)) / 864e5);
    return { iso: o.iso, label: o.label, away: away, cut: cut, window: c.window || '' };
  };
  function todayIso(){ var t = torontoNow(); return new Date(Date.UTC(t.y, t.m, t.d)).toISOString().slice(0, 10); }

  /* "At your door Friday" (snippets/duo-next-day.liquid). */
  function nextDays(){
    document.querySelectorAll('[data-duo-next]').forEach(function(el){
      var first = el.dataset.start || (window.DUO_DELIVERY && window.DUO_DELIVERY.start) || '';
      var nd = nextDelivery(el.dataset.days, parseInt(el.dataset.cutoff || '20', 10), first);
      if (!nd) return;
      var win = el.dataset.window ? ', ' + el.dataset.window : '';
      // data-short: the line under the buy button ("At your door Sunday, October 4, 4 to 7pm")
      if (el.hasAttribute('data-short')) el.textContent = 'At your door ' + nd.label + win;
      else el.textContent = (first && todayIso() < first ? 'First delivery: ' : 'Order now and it\'s at your door ') + nd.label + win + '.';
    });
  }

  /* Every order carries its delivery day as two cart attributes, "Delivery date"
     (2026-10-03, for sorting) and "Delivery day" (the words). The Order Printer make
     sheet and can labels read them (docs/ops/). Stamped when a page loads with a stale
     day, after an add, before the cart's checkout button submits, and before Your usual
     goes to checkout. The templates fall back to the order time if it is ever missing.
     She can pick another of the next four delivery days and a preferred hour in the cart
     (2026-09-30, snippets/duo-cart-value.liquid part 'when'): a day she picked is kept
     for as long as its cut-off has not passed, then it falls back to the next day.
     "Preferred time" rides along; nothing is promised, we do our best. */
  function timeSlots(){
    var c = window.DUO_DELIVERY || {};
    return String(c.slots || '').split(',').map(function(s){ return s.trim(); }).filter(Boolean);
  }
  function deliveryAttrs(){
    var c = window.DUO_DELIVERY;
    if (!c || !c.open) return null;
    var opts = deliveryOptions(c.days, parseInt(c.cutoff, 10) || 20, c.start, 4);
    if (!opts.length) return null;
    var pick = opts[0];
    if (c.stamped) opts.forEach(function(o){ if (o.iso === c.stamped) pick = o; });
    var a = { 'Delivery date': pick.iso, 'Delivery day': pick.label + (c.window ? ', ' + c.window : '') };
    var slots = timeSlots();
    if (slots.length) a['Preferred time'] = slots.indexOf(c.time) > -1 ? c.time : 'Any time' + (c.window ? ', ' + c.window : '');
    return a;
  }
  /* The day and time chips in the cart: the pick shows at once and is saved on the cart. */
  function whenPick(){
    if (window.__duoWhenBound) return;
    window.__duoWhenBound = true;
    document.addEventListener('click', function(e){
      var b = e.target.closest && e.target.closest('[data-duo-when-day],[data-duo-when-time]');
      var c = window.DUO_DELIVERY;
      if (!b || !c) return;
      var box = b.closest('[data-duo-when]'), day = b.hasAttribute('data-duo-when-day');
      if (!box) return;
      box.querySelectorAll(day ? '[data-duo-when-day]' : '[data-duo-when-time]').forEach(function(x){ x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      if (day) c.stamped = b.getAttribute('data-duo-when-day'); else c.time = b.getAttribute('data-duo-when-time');
      var a = deliveryAttrs();
      if (!a) return;
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ attributes: a }) }).catch(function(){});
    });
  }

  /* Smallest order (2026-09-30): the cart's checkout button waits until the cart reaches
     the smallest order we deliver (snippets/duo-cart-value.liquid part 'gate'). Liquid
     knows her zone only from a saved address; for everyone else this reads the postal
     code she checked on this device and corrects the button and the line under the
     meter. Horizon re-renders the cart after every change, so it runs again then. */
  function cents(n){ return '$' + (n % 100 ? (n / 100).toFixed(2) : String(n / 100)); }
  function minGate(){
    var fsa = '';
    try { fsa = (localStorage.getItem('duo:zip') || '').toUpperCase().replace(/\s+/g, '').slice(0, 3); } catch (e) {}
    if (fsa.length !== 3) return;
    document.querySelectorAll('[data-duo-gate],[data-duo-minline]').forEach(function(el){
      var d = el.dataset;
      if (d.zone || !+d.items || !+d.min) return;   // her saved address already decided it, or nothing to hold
      var zone = (d.zoneFsas || '').indexOf(fsa) > -1 ? 'zone' : ((d.nearFsas || '').indexOf(fsa) > -1 ? 'near' : '');
      if (!zone) return;
      var need = zone === 'near' ? +d.nearMin : +d.min, short = Math.max(0, need - (+d.total));
      if (el.hasAttribute('data-duo-minline')) {
        var line = zone === 'near' ? 'The smallest order we deliver to ' + d.nearName + ' is ' + cents(need) + '.' : 'The smallest order we deliver is ' + cents(need) + '.';
        if (el.textContent.trim() !== line) el.textContent = line;
        if (el.hidden !== (short === 0)) el.hidden = short === 0;
        return;
      }
      var lab = el.querySelector('.button-text'), text = short > 0 ? 'Add ' + cents(short) + ' more to check out' : (d.label || 'Check out');
      if (lab && lab.textContent.trim() !== text) lab.textContent = text;
      if (el.disabled !== (short > 0)) el.disabled = short > 0;
    });
  }
  function minWatch(){
    if (window.__duoMinBound) return;
    window.__duoMinBound = true;
    minGate();
    document.addEventListener('duo:zip', minGate);
    if (!window.MutationObserver || !document.body) return;
    var raf = 0;
    new MutationObserver(function(){
      if (!document.querySelector('[data-duo-gate]')) return;
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(minGate);
    }).observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['data-total', 'data-zone'] });
  }
  function stampDelivery(force){
    var c = window.DUO_DELIVERY, a = deliveryAttrs();
    if (!a) return Promise.resolve();
    if (!force && (!c.items || c.stamped === a['Delivery date'])) return Promise.resolve();
    return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ attributes: a }) })
      .then(function(r){ if (r.ok) { c.stamped = a['Delivery date']; c.items = c.items || 1; } })
      .catch(function(){});
  }
  function stampOnCheckout(){
    if (window.__duoStampBound) return;
    window.__duoStampBound = true;
    ['cart:updated', 'duo:added'].forEach(function(ev){
      document.addEventListener(ev, function(){ if (window.DUO_DELIVERY) window.DUO_DELIVERY.items = 1; stampDelivery(); });
    });
    // The cart's checkout button posts the cart form: the day rides along as attributes[...] inputs.
    document.addEventListener('submit', function(e){
      var f = e.target, s = e.submitter;
      if (!f || !s || s.name !== 'checkout') return;
      var a = deliveryAttrs();
      if (!a) return;
      Object.keys(a).forEach(function(k){
        var i = f.querySelector('input[data-duo-stamp="' + k + '"]');
        if (!i) { i = document.createElement('input'); i.type = 'hidden'; i.name = 'attributes[' + k + ']'; i.setAttribute('data-duo-stamp', k); f.appendChild(i); }
        i.value = a[k];
      });
    }, true);
  }

  /* Send this drink to a friend: the link opens her exact build. */
  function shareAndOpen(){
    if (window.__duoShareBound) return;
    window.__duoShareBound = true;
    document.addEventListener('click', function(e){
      // "+ Stickers with their name" (snippets/duo-kname.liquid): opens the field in place
      var k = e.target.closest && e.target.closest('[data-duo-kname-toggle]');
      if (k) {
        var kb = k.closest('[data-duo-kname-box]'), ko = kb && kb.querySelector('.duo-kname__open');
        if (!ko) return;
        ko.hidden = false;
        k.hidden = true;
        var ki = ko.querySelector('[data-duo-kname]');
        if (ki) ki.focus();
        return;
      }
      var b = e.target.closest && e.target.closest('[data-duo-share]');
      if (b) {
        var root = document.querySelector('[data-duo-build]');
        var url = root && root.duoBuilder ? root.duoBuilder.shareUrl() : location.origin + location.pathname;
        var t = document.querySelector('.duo-pdp__title');
        var name = t ? t.textContent.trim() : 'DUO';
        var out = (b.parentElement || document).querySelector('[data-duo-share-out]');
        var say = function(m){ if (out) out.textContent = m; };
        if (navigator.share) { navigator.share({ title: 'DUO', text: 'I built a ' + name + ' on DUO. Here it is:', url: url }).catch(function(){}); return; }
        if (navigator.clipboard) navigator.clipboard.writeText(url).then(function(){ say('Link copied. Paste it anywhere.'); }, function(){ say(url); });
        else say(url);
        return;
      }
      var o = e.target.closest && e.target.closest('[data-duo-open-delivery]');
      if (o) {
        var z = document.querySelector('.duo-more [data-duo-zip]') || document.querySelector('[data-duo-zip]');
        if (!z) { location.href = '/pages/delivery'; return; }
        var det = z.closest('details'); if (det) det.open = true;
        z.scrollIntoView({ behavior: 'smooth', block: 'center' });
        var i = z.querySelector('input'); if (i) setTimeout(function(){ i.focus({ preventScroll: true }); }, 350);
      }
    });
  }

  /* "Your usual" (snippets/duo-usual.liquid): her last order when she is signed in,
     otherwise the last drink added on this device (duo:last, written by the
     builder). The card is filled by the snippet's own script while the page is
     read, so it is in place before the first paint (2026-09-28); this wires the
     Reorder button. Reorder puts the same lines back in the cart, each build with a
     fresh _build id so Plus Ones stay tied to their drink, then goes straight to
     checkout. "Change it" opens the drink with the same build ready. */
  function usual(){
    document.querySelectorAll('[data-duo-usual]').forEach(function(box){
      if (box.dataset.bound) return;
      box.dataset.bound = '1';
      var u = window.duoUsualFill ? window.duoUsualFill(box) : null;
      if (!u) return;
      var d = u.d;
      var btn = box.querySelector('[data-duo-usual-add]'), err = box.querySelector('[data-duo-usual-err]');
      btn.addEventListener('click', function(){
        if (btn.classList.contains('is-busy')) return;
        // not signed in: prices and checkout are for members, so the code comes first; she comes back here to reorder
        if (document.documentElement.hasAttribute('data-duo-guest')) { signIn('', location.pathname); return; }
        btn.classList.add('is-busy');
        var ids = {}, fresh = 'b' + Date.now().toString(36);
        var items = d.items.map(function(i, n){
          var props = {};
          Object.keys(i.properties || {}).forEach(function(k){ props[k] = i.properties[k]; });
          var old = props._build || 'one';
          if (!ids[old]) ids[old] = fresh + Object.keys(ids).length;
          props._build = ids[old];
          return { id: Number(i.id), quantity: i.quantity, properties: props };
        });
        // newest line lands on top of the cart, so post backwards: drink first, then its Plus Ones, then the Little
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items.slice().reverse() }) })
          .then(function(res){ return res.json().then(function(j){ return { ok: res.ok, body: j }; }); })
          .then(function(res){
            if (!res.ok) throw new Error(res.body && res.body.description ? res.body.description : 'Something in it is not available right now.');
            // under the smallest order we deliver, checkout would offer no delivery: the cart says how much is missing
            var min = window.DUO_DELIVERY && +window.DUO_DELIVERY.min || 0;
            return stampDelivery(true)
              .then(function(){ return min ? fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function(r){ return r.json(); }) : null; })
              .then(function(cart){ window.location.href = cart && cart.total_price < min ? '/cart' : '/checkout'; }, function(){ window.location.href = '/checkout'; });
          })
          .catch(function(e){ btn.classList.remove('is-busy'); if (err) { err.textContent = e.message + ' Tap Change it to build it again.'; err.hidden = false; } });
      });
    });
  }

  /* Becoming a member (prices only in private, 2026-09-29).

     A visitor's "See your price" (Paul, 2026-10-01: "I want what they build to go
     into the cart"): her drink goes into the cart first, then she signs in on
     Shopify's page (her email, a 6-digit code, or Shop) and comes back to the cart
     with her drink and her total. The drink page's builder does it for drinks
     (assets/duo-builder.js); guestAdd() does it for a plain product form (Little DUO
     pages). No email panel of ours: her email is typed once, on Shopify's page.

     The lines she added are also kept on this device (duo:pending). Signed in and
     the cart came back without them: pending() puts them back, once.

     A Secret Menu signup (hero, Secret Menu section; input[data-duo-join="list"]) is
     the list itself, so its form posts first; the note in sessionStorage then
     carries her on to the sign-in once Shopify brings her back with
     ?customer_posted=true, so signing up for the list also makes her a member. */
  function signIn(email, ret){
    var q = new URLSearchParams();
    q.set('return_to', ret && ret.charAt(0) === '/' ? ret : '/');
    if (email) q.set('login_hint', email);
    window.location.href = '/customer_authentication/login?' + q.toString();
  }
  function readPending(){
    try { return JSON.parse(localStorage.getItem('duo:pending') || 'null'); } catch (e) { return null; }
  }
  function clearPending(){ try { localStorage.removeItem('duo:pending'); } catch (e) {} }
  function postJson(path, body){
    return fetch(path, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) });
  }
  function pending(){
    if (window.DUO_DELIVERY && window.DUO_DELIVERY.open === false) return;   // ordering closed: nothing goes back in the cart, she keeps it for later
    var p = readPending();
    if (!p) return;
    var fresh = p.at && Date.now() - p.at < 72e5 && Array.isArray(p.items) && p.items.length && Array.isArray(p.ids);
    if (!fresh) { clearPending(); return; }
    if (root.hasAttribute('data-duo-guest')) return;   // not signed in yet: her drink waits in the cart
    clearPending();
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(c){
        var have = (c.items || []).some(function(i){ return i.properties && p.ids.indexOf(i.properties._build) > -1; });
        if (have) return;
        return postJson('/cart/add.js', { items: p.items }).then(function(r){
          if (r.ok && location.pathname.indexOf('/cart') === 0) location.reload();
        });
      })
      .catch(function(){});
  }
  function guestAdd(){
    document.querySelectorAll('[data-duo-guest-add]').forEach(function(b){
      if (b.dataset.bound) return;
      b.dataset.bound = '1';
      b.addEventListener('click', function(){
        var f = b.closest('form');
        if (!f || b.classList.contains('is-busy')) return;
        var fd = new FormData(f), id = fd.get('id'), props = {};
        if (!id) return;
        fd.forEach(function(v, k){ var m = /^properties\[(.+)\]$/.exec(k); if (m && String(v).trim()) props[m[1]] = String(v).trim(); });
        props._build = 'b' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
        var item = { id: Number(id), quantity: 1, properties: props };
        var was = b.textContent;
        b.classList.add('is-busy');
        b.textContent = 'Saving your drink';
        var fail = function(){ b.classList.remove('is-busy'); b.textContent = was; };
        // a second tap before she signs in replaces the first one, never doubles it
        var prior = readPending(), drop = prior && Array.isArray(prior.ids) && Date.now() - prior.at < 72e5 ? prior.ids : [];
        var pre = !drop.length ? Promise.resolve() : fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function(r){ return r.json(); })
          .then(function(c){
            var up = {}, n = 0;
            (c.items || []).forEach(function(i){ if (i.properties && drop.indexOf(i.properties._build) > -1) { up[i.key] = 0; n++; } });
            if (n) return postJson('/cart/update.js', { updates: up });
          })
          .catch(function(){});
        pre.then(function(){ return postJson('/cart/add.js', { items: [item] }); })
          .then(function(r){
            if (!r.ok) { fail(); return; }
            // the kid's sticker name stays on the order, never on the device (Paul, 2026-09-29)
            var kp = {};
            Object.keys(props).forEach(function(k){ if (k !== 'Name for stickers') kp[k] = props[k]; });
            try { localStorage.setItem('duo:pending', JSON.stringify({ ids: [props._build], items: [{ id: item.id, quantity: 1, properties: kp }], at: Date.now() })); } catch (e) {}
            signIn('', '/cart');
          })
          .catch(fail);
      });
    });
  }
  function join(){
    var note = null;
    try { note = JSON.parse(sessionStorage.getItem('duo:join') || 'null'); sessionStorage.removeItem('duo:join'); } catch (e) { note = null; }
    if (note && /[?&]customer_posted=true/.test(location.search) && document.documentElement.hasAttribute('data-duo-guest')) {
      signIn(note.email, note.ret);
      return true;
    }
    document.querySelectorAll('input[data-duo-join]').forEach(function(mark){
      var f = mark.form;
      if (!f || f.dataset.duoJoinBound) return;
      f.dataset.duoJoinBound = '1';
      f.addEventListener('submit', function(){
        var em = f.querySelector('input[type=email]');
        var email = em ? em.value.trim() : '';
        if (!email || (em.checkValidity && !em.checkValidity())) return;
        var ret = mark.dataset.return || (location.pathname + location.search.replace(/[?&]customer_posted=true/, ''));
        try { sessionStorage.setItem('duo:join', JSON.stringify({ email: email, ret: ret })); } catch (x) { /* she signs in from the header instead */ }
      });
    });
    return false;
  }
  // back from the sign-in with the Back button: a busy button is put back
  window.addEventListener('pageshow', function(e){
    if (!e.persisted) return;
    document.querySelectorAll('[data-duo-guest-add].is-busy').forEach(function(b){ b.classList.remove('is-busy'); b.textContent = 'See your price'; });
  });

  function init(){
    if (join()) return;
    pending(); guestAdd();
    posted(); nextDays(); stampOnCheckout(); stampDelivery(); whenPick(); minWatch(); shareAndOpen(); countdowns(); videos(); sticky(); stillLoops(); qty(); zips(); saveOpen(); usual();
    if (location.pathname.indexOf('/cart') === 0) tidyCart();
  }
  ['cart:update', 'cart:updated', 'cart:refresh'].forEach(function(ev){ document.addEventListener(ev, function(){ setTimeout(tidyCart, 300); }); });
  /* Horizon's cart page changes lines without a reload and says so with the
     standard 'shopify:cart:lines-update' event; sweep once the change is saved. */
  document.addEventListener('shopify:cart:lines-update', function(e){
    if (e && e.duoTidy) return;   // our own redraw
    if (location.pathname.indexOf('/cart') !== 0 && !document.querySelector('cart-items-component .duo-p1row')) return;
    var pr = e && (e.promise || (e.detail && e.detail.promise));
    if (pr && pr.then) pr.then(function(){ setTimeout(tidyCart, 100); }, function(){}); else setTimeout(tidyCart, 900);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function(){ join(); countdowns(); videos(); qty(); zips(); });
})();

/* v3 layers (Oct 28, 2026; spec docs/reports/design-preview/comps-v3.html). A section row painted in
   two colours at the can tilt (.duo-ly in assets/duo.css) whose seam runs through one drink card's own
   seam, so the row reads as the drink's layers carrying on. Mark the row data-duo-ly and, inside it,
   the card data-duo-ly-anchor (or give data-duo-ly a selector). A .duo-split anchor gives its layer
   point from its CSS; any other anchor gives data-duo-ly-at="0.5,0.7" (fractions of its box). Sets
   --ly-x / --ly-y (px from the row's top left). Runs on load, on resize, on duo:swapped, and on
   window.duoLayers(root) after a section changes its focused card. Only a background changes:
   nothing on the page moves. */
(function(){
  if (window.duoLayers) return;
  function num(cs, n, d){ var v = parseFloat(cs.getPropertyValue(n)); return isNaN(v) ? d : v; }
  function point(a){
    var r = a.getBoundingClientRect(), at = a.getAttribute('data-duo-ly-at');
    if (at) { var f = at.split(','); return [r.left + r.width * (+f[0] || 0), r.top + r.height * (+f[1] || 0)]; }
    var cs = getComputedStyle(a), t = num(cs, '--sp-t', .07), h = num(cs, '--sp-h', .86);
    var ax = num(cs, '--sp-ax', .5), ay = num(cs, '--sp-ay', .55), k = num(cs, '--sp-r', .494);
    return [r.left + r.width / 2 + (ax - .5) * k * h * r.height, r.top + (t + ay * h) * r.height];
  }
  function one(row){
    var sel = row.getAttribute('data-duo-ly'), a = null;
    try { a = sel ? row.querySelector(sel) : null; } catch (e) { a = null; }
    if (!a) a = row.querySelector('[data-duo-ly-anchor]');
    if (!a || !a.getClientRects().length) return;
    var fr = row.getBoundingClientRect(), p = point(a);
    row.style.setProperty('--ly-x', (p[0] - fr.left).toFixed(1) + 'px');
    row.style.setProperty('--ly-y', (p[1] - fr.top).toFixed(1) + 'px');
  }
  var ro = window.ResizeObserver ? new ResizeObserver(function(es){ es.forEach(function(e){ one(e.target); }); }) : null;
  window.duoLayers = function(root){
    (root || document).querySelectorAll('[data-duo-ly]').forEach(function(row){
      one(row);
      if (ro && !row.__duoLy) { row.__duoLy = true; ro.observe(row); }
    });
  };
  function run(){ window.duoLayers(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  window.addEventListener('load', run);
  document.addEventListener('duo:swapped', run);
  document.addEventListener('shopify:section:load', run);
})();
